import { getEnvVar } from 'utils/envVars'

export const RFP_STATE = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  CLOSED: 'closed',
  FINALIZED: 'finalized',
}
export const LOADSMART = {
  dot: '2524523',
  email: 'rfp@loadsmart.com',
}

export const ENV = (process.env.REACT_APP_ENVIRONMENT || '').toLowerCase()
export const RELEASE_VERSION = (
  process.env.REACT_APP_RELEASE_VERSION || ''
).toLowerCase()
export const SENTRY_DSN = getEnvVar('SENTRY_DSN')
export const MIXPANEL_TOKEN = getEnvVar('MIXPANEL_TOKEN')
export const GA_TRACKING_ID = getEnvVar('GA_TRACKING_ID')
export const HOTJAR_ID = +getEnvVar('HOTJAR_ID')
export const HOTJAR_VERSION = +getEnvVar('HOTJAR_VERSION')
export const ALLOWED_FILETYPES = [
  '.csv',
  '.xla',
  '.xlam',
  '.xlsb',
  '.xlsm',
  '.xlsx',
  '.xlt',
  '.xltm',
  '.xltx',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'text/csv',
  'text/tab-separated-values',
]
export const SUPPORT_EMAIL = 'info@rfpguide.com'
export const DATADOG_CLIENT_TOKEN = getEnvVar('DATADOG_CLIENT_TOKEN')
export const DATADOG_SERVICE_NAME = 'rfp-web'
